import React, { useContext } from 'react';
import { message, Form, Input, Select, Button } from 'antd';
import { Context } from '../../../defaults';
import { createTopics } from '../../../actions';

export function TopicsAdd({ subjects, setAdded, setActive }) {
  const [form] = Form.useForm();
  const { dictionary, language, setLoading } = useContext(Context);
  const requiredMessage = dictionary?.FillTheField[language];
  const maxLengthMessage = dictionary?.MaxLengthField[language];

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  const onSaveTopics = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) =>
        createTopics(values)
          .then(() => {
            setLoading(false);
            setAdded(true);
            setActive('2');
            message.success(dictionary?.SuccessfullyAdded[language], 4);
            form.resetFields();
          })
          .catch(() => {
            message.error(dictionary?.SomethingWentWrong[language], 4);
            setLoading(false);
          }),
      )
      .catch((error) => {
        setLoading(false);
        message.error(dictionary?.FormValidationFail[language], 4);
      });
  };

  return (
    <Form form={form} labelCol={{ span: 7 }} wrapperCol={{ span: 18 }} layout="horizontal">
      <Form.Item name="id" style={{ display: 'none' }}>
        <Input type={'hidden'} value={null} />
      </Form.Item>
      <Form.Item
        label={dictionary?.TopicName[language]}
        name="name"
        rules={[
          { required: true, message: requiredMessage },
          { max: 100, message: maxLengthMessage },
        ]}>
        <Input placeholder={dictionary?.TopicName[language]} />
      </Form.Item>
      <Form.Item
        name="subjectId"
        label={dictionary?.Subject[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select
          placeholder={dictionary?.Subject[language]}
          allowClear={true}
          showSearch={true}
          filterOption={(search, item) => {
            return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
          }}>
          {subjects &&
            subjects.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item name="userLogin" style={{ display: 'none' }}>
        <Input type={'hidden'} value={null} />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type="primary" size="large" htmlType="submit" onClick={() => onSaveTopics()}>
          {dictionary?.Add[language]}
        </Button>
      </Form.Item>
    </Form>
  );
}
